<template>
<div>
  <div class="order-data">

    <div class="wrapper d-flex align-items-center mb-1">
      <h3 class="font-weight-bold m-0">Pedido #{{ reference }} {{ sellerStatus ? ' - Status ' + sellerStatus : ''}}</h3>
      <!-- <span class="badge badge-success badge-pill badge-lg ml-2">Aprovado</span> -->
    </div>

    <!-- <img src="https://via.placeholder.com/150" alt=""
    class="client-img"> -->

    <table class="table mt-4">
      <tbody class="last-child-right" v-for="i in cart" v-bind:key="i.id">
        <tr>
          <td>{{ i.quantity}}x {{ i.description }}</td>
          <td>{{ i.amount | numeral('$ 0,0.00') }}</td>
        </tr>
        <div v-if="i.description == 'Passagem Aérea'">
          <tr v-if="i.outbound">
            <td><b>Saída</b></td>
            <td>{{ i.outbound.departureTime | moment-complete }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Local de partida</td>
            <td>{{ i.outbound.departureLocation }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Local de chegada</td>
            <td>{{ i.outbound.arrivalLocation }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Empresa</td>
            <td>{{ i.outbound.airline }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td><b>Saída</b></td>
            <td>{{ i.inbound.departureTime | moment-complete }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Local de partida</td>
            <td>{{ i.inbound.departureLocation }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Local de chegada</td>
            <td>{{ i.inbound.arrivalLocation }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Empresa</td>
            <td>{{ i.inbound.airline }}</td>
          </tr>
          <tr v-if="i.quantityDescription">
            <td>Passageiros</td>
            <td>{{ i.quantityDescription }}</td>
          </tr>
        </div>
        <div v-if="i.description == 'Hospedagem'">
          <tr v-if="i.hotel">
            <td>Data entrada</td>
            <td>{{ i.hotel.checkinDate | moment-complete }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Data saída</td>
            <td>{{ i.hotel.checkoutDate | moment-complete }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Nome</td>
            <td>{{ i.hotel.name }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Cidade</td>
            <td>{{ i.hotel.city }}</td>
          </tr>
          <tr v-if="i.quantityDescription">
            <td>Hóspedes</td>
            <td>{{ i.quantityDescription }}</td>
          </tr>
        </div>
        <div v-if="i.description == 'Hotel+voo'">
          <tr v-if="i.hotel">
            <td><b>Hotel</b></td>
          </tr>
          <tr v-if="i.hotel">
            <td>Data entrada</td>
            <td>{{ i.hotel.checkinDate | moment-complete }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Data saída</td>
            <td>{{ i.hotel.checkoutDate | moment-complete }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Nome</td>
            <td>{{ i.hotel.name }}</td>
          </tr>
          <tr v-if="i.hotel">
            <td>Cidade</td>
            <td>{{ i.hotel.city }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td><b>Voo</b></td>
          </tr>
          <tr v-if="i.outbound">
            <td><b>Saída</b></td>
            <td>{{ i.outbound.departureTime | moment-complete }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Local de partida</td>
            <td>{{ i.outbound.departureLocation }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Local de chegada</td>
            <td>{{ i.outbound.arrivalLocation }}</td>
          </tr>
          <tr v-if="i.outbound">
            <td>Empresa</td>
            <td>{{ i.outbound.airline }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td><b>Saída</b></td>
            <td>{{ i.inbound.departureTime | moment-complete }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Local de partida</td>
            <td>{{ i.inbound.departureLocation }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Local de chegada</td>
            <td>{{ i.inbound.arrivalLocation }}</td>
          </tr>
          <tr v-if="i.inbound">
            <td>Empresa</td>
            <td>{{ i.inbound.airline }}</td>
          </tr>
          <tr v-if="i.quantityDescription">
            <td>Viajantes</td>
            <td>{{ i.quantityDescription }}</td>
          </tr>
        </div>
      </tbody>
    </table>

    <div v-if="payment.other">
      <div class="form-group row" v-for="other in payment.other" v-bind:key="other.id">
        <label class="col-sm-6 col-form-label">{{ other.description }}</label>
        <div class="col-sm-6">
          <div readonly class="form-control-plaintext">{{ other.amount | numeral('$ 0,0.00') }}</div>
        </div>
      </div>
    </div>

    <div class="wrapper d-flex float-right">
      <div class="text-right mr-4">
        <p>Frete</p>
        <p v-if="payment.discount">Desconto</p>
        <h5 class="font-weight-bold">Valor total</h5>
      </div>
      <div class="text-right">
        <p>{{ shipping.amount | numeral('$ 0,0.00') }}</p>
        <p v-if="payment.discount">{{ payment.discount | numeral('$ 0,0.00') }}</p>
        <h5 class="font-weight-bold text-success">{{ payment.amount | numeral('$ 0,0.00') }}</h5>
      </div>
    </div>

    <div lass="wrapper d-flex float-right" v-if="cartUrl">
      <div class="text-right mr-4">
        <p>Link para carrinho {{ cartUrl }}</p>
      </div>
    </div>

  </div>
</div>
</template>
<script>
export default {
  props: ['cart', 'reference', 'payment', 'shipping', 'sellerStatus', 'cartUrl']
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/partial/cards/order/OrderDetails.vue